import View               from '@widesk-ui/components/View';
import { RedoOutlined }   from '@ant-design/icons';
import { UndoOutlined }   from '@ant-design/icons';
import Tooltip            from '@widesk-ui/components/Tooltip';
import React              from 'react';
import { observer }       from 'mobx-react-lite';
import currentEditorStore from '@/TokamapEditor/stores/currentEditorStore';
import buildingPickStore  from '@/TokamapEditor/stores/buildingPickStore';
import useDesignTokens    from '@/hooks/useDesignTokens';
import { DesignTokens }   from '@/hooks/useDesignTokens';

// Segment droit de la barre flottante (voir `MapFloatingControls`) : annuler/rétablir agit sur le
// contenu de la carte, ces boutons vivent donc sur le plan et non dans la barre du haut. Rendu à
// plat (ni fond, ni bordure, ni ombre) : c'est la barre qui porte le relief.
const UndoRedo = observer(() => {
	const editor = currentEditorStore.get;
	const tokens = useDesignTokens();

	const [canUndo, setCanUndo] = React.useState(false);
	const [canRedo, setCanRedo] = React.useState(false);

	React.useEffect(() => {
		if (!editor) return;

		const sync = () => {
			setCanUndo(editor.history.canUndo());
			setCanRedo(editor.history.canRedo());
		};
		sync();

		return editor.history.onChange(sync);
	}, [editor]);

	if (!currentEditorStore.isCenterDefined) return null;
	if (!currentEditorStore.get) return null;

	return (
		<View row centerV gap={2} px={4}>
			<Btn
				disabled={!canUndo || currentEditorStore.isDrawing || buildingPickStore.active}
				onClick={() => editor.history.undo()}
				title="Annuler"
				tokens={tokens}
			>
				<UndoOutlined style={{ fontSize: 17 }} />
			</Btn>

			<Btn
				disabled={!canRedo || currentEditorStore.isDrawing || buildingPickStore.active}
				onClick={() => editor.history.redo()}
				title="Rétablir"
				tokens={tokens}
			>
				<RedoOutlined style={{ fontSize: 17 }} />
			</Btn>
		</View>
	);
});

const Btn = (props: {
	disabled: boolean;
	children: React.ReactNode;
	onClick: () => void;
	title: string;
	tokens: DesignTokens;
}) => {
	const { tokens } = props;

	return (
		<Tooltip title={props.title} placement="bottom">
			<div>
				<View
					h={30}
					w={30}
					br={8}
					center
					color={props.disabled ? tokens.text.disabled : tokens.text.secondary}
					style={{ cursor: props.disabled ? 'not-allowed' : 'pointer' }}
					hover={props.disabled ? undefined : { bg: tokens.surface.subtle, color: tokens.text.default }}
					onClick={props.disabled ? undefined : props.onClick}
				>
					{props.children}
				</View>
			</div>
		</Tooltip>
	);
};

export default UndoRedo;
